import type { SVGProps } from 'react'
const SvgSySwap = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M16.84 5.797a.75.75 0 0 0-.75.75v13.617a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V6.547a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path d="M12.764 15.318a.75.75 0 0 0-.532.22.75.75 0 0 0-.002 1.06l4.079 4.095a.75.75 0 0 0 1.062 0l4.078-4.095a.75.75 0 0 0-.002-1.06.75.75 0 0 0-1.06.001l-3.547 3.563-3.547-3.563a.75.75 0 0 0-.53-.22" />
			<path
				d="M6.912 3.082a.75.75 0 0 0-.75.75v13.62a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V3.831a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path d="M6.912 3.082a.75.75 0 0 0-.533.22L2.303 7.4a.75.75 0 0 0 .002 1.06.75.75 0 0 0 1.06-.001L6.91 4.896l3.547 3.563a.75.75 0 0 0 1.06.002.75.75 0 0 0 .004-1.06L7.443 3.302a.75.75 0 0 0-.53-.221" />
		</g>
	</svg>
)
export default SvgSySwap
